export var POOL;

(function (POOL) {
  POOL["UNISWAP"] = "Uniswap";
  POOL["SUSHI"] = "Sushiswap";
})(POOL || (POOL = {}));